import { AxiosResponse } from "axios";
import { http } from "../utils/http";
import {
  ICreateRecommendPlace,
  IFilterRecommendPlacePagination,
  IRecommendPlace,
  IUpdateRecommendPlace,
} from "../interface/recommend-place";

export const filterRecommendPlacesApi = async (payload: {
  keyword?: string;
  status?: number[];
  page: number;
  limit: number;
}): Promise<AxiosResponse<IFilterRecommendPlacePagination>> => {
  return await http.get("/v1/admin/recommend-places/filter", payload);
};

export const getRecommendPlaceByIdApi = async (
  id: string
): Promise<AxiosResponse<IRecommendPlace>> => {
  return await http.get(`/v1/admin/recommend-places/${id}`);
};

export const createRecommendPlaceApi = async (
  payload: ICreateRecommendPlace
): Promise<AxiosResponse<IRecommendPlace>> => {
  return await http.post("/v1/admin/recommend-places", payload);
};

export const updateRecommendPlaceApi = async (
  id: string,
  payload: IUpdateRecommendPlace
): Promise<AxiosResponse<IRecommendPlace>> => {
  return await http.put(`/v1/admin/recommend-places/${id}`, payload);
};

export const deleteRecommendPlaceApi = async (
  id: string
): Promise<AxiosResponse<void>> => {
  return await http.del(`/v1/admin/recommend-places/${id}`);
};

// Public API for getting active recommend places
export const getActiveRecommendPlacesApi = async (): Promise<
  AxiosResponse<IRecommendPlace[]>
> => {
  return await http.get("/v1/recommend-places");
};
